import { styled } from '@mui/material/styles'
import Box from '@/components/common/Box'
import { colors, focusVisible, radius, sizing, spacing, typePresets } from '@/styles/designTokens'

export const Overlay = styled('main')({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	minHeight: '100vh',
})

export const Card = styled(Box)({
	padding: spacing.xxl,
	maxWidth: sizing.gateCardMaxWidth,
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	gap: spacing.xl,
})

export const LocationHeading = styled('h1')({
	...typePresets.headingXxl,
	margin: 0,
	color: colors.textPrimary,
	textAlign: 'center',
	wordBreak: 'break-word',
})

export const CtaLink = styled('a')({
	...typePresets.labelLg,
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	padding: `${spacing.sm}px ${spacing.xl}px`,
	backgroundColor: colors.brand,
	color: colors.textInverse,
	borderRadius: radius.pill,
	textDecoration: 'none',
	cursor: 'pointer',
	'&:hover': {
		backgroundColor: colors.brandHover,
	},
	'&:focus-visible': {
		outline: `${focusVisible.outline} ${colors.overlayHeavy}`,
		outlineOffset: focusVisible.outlineOffset,
		borderRadius: radius.pill,
	},
})
